import { useMutation, useQuery, useQueryClient } from 'react-query'
import { queryKeys } from 'constants/queryKeys'
import { getApplications } from 'api/GetRequests'
import { Item } from './types/ItemTypes'

const useApplications = () => useQuery<Item[]>([queryKeys.applications], getApplications, {})

export default useApplications
